import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import useMediaQuery from "@mui/material/useMediaQuery";
import NoImage from "./../../images/Banner/no_image.jpeg";
import { international } from "../../Model/Auction";
import publicUrls from "../../routes/publicUrls";

// Sotheby's style: Minimalist, Serif headers, San-serif body, lots of whitespace.
export default function Auction() {
  const isDesktop = useMediaQuery("(min-width:1000px)");
  const [books, setBooks] = useState([]);
  const [auctionstatus, setAuctionstatus] = useState("");
  const [loading, setLoading] = useState(false);

  const fetchData = async (status) => {
    setLoading(true);
    try {
      const results = await international(status);
      if (results.sucess === false) {
        setBooks([]);
      } else {
        setBooks(results);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData("");
  }, []);

  const handleFilter = (status) => {
    const filterValue = status === "All" ? "" : status;
    setAuctionstatus(filterValue);
    fetchData(filterValue);
  };

  const gotoPage = (id, slug, type) => {
    if (type === "EXHIBITION") {
      window.location.href = publicUrls.exhibition(slug, id);
    } else {
      window.location.href = publicUrls.auction(slug, id);
    }
  };

  return (
    <div style={{ backgroundColor: "#fff", minHeight: "100vh", fontFamily: "'Inter', sans-serif" }}>
      <section style={{ paddingTop: isDesktop ? "60px" : "30px" }}>
        <div className="container">
          
          <div style={{ borderBottom: "1px solid #e0e0e0", marginBottom: "40px", paddingBottom: "20px" }}>
            <h1 style={{ 
              fontFamily: "serif", 
              fontSize: isDesktop ? "42px" : "32px", 
              fontWeight: "400",
              margin: 0 
            }}>
              Exhibitions & Auctions
            </h1>
          </div>

          
          <div style={{ 
            display: "flex", 
            gap: "30px", 
            marginBottom: "40px",
            textTransform: "uppercase",
            letterSpacing: "1.5px",
            fontSize: "13px",
            fontWeight: "600"
          }}>
            {["All", "UPCOMING", "PREVIOUS"].map((status) => (
              <span
                key={status}
                onClick={() => handleFilter(status)}
                style={{
                  cursor: "pointer",
                  color: (status === "All" && auctionstatus === "") || auctionstatus === status ? "#000" : "#999",
                  borderBottom: (status === "All" && auctionstatus === "") || auctionstatus === status ? "2px solid #000" : "2px solid transparent",
                  paddingBottom: "5px",
                  transition: "0.3s"
                }}
              >
                {status === "UPCOMING" ? "Ongoing" : status}
              </span>
            ))}
          </div>

          
          <div className="row">
            {books.length > 0 ? (
              books.map((item, i) => {
                const dateStart = new Date(item.date_start).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
                const dateEnd = new Date(item.date_end).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

                return (
                  <div className="col-xl-4 col-md-6" key={i} style={{ marginBottom: "60px" }}>
                    <div 
                      onClick={() => gotoPage(item.id, item.c_slug, item.c_type)}
                      style={{ cursor: "pointer", group: "hover" }}
                    >
                      
                      <div style={{ 
                        overflow: "hidden", 
                        backgroundColor: "#f9f9f9",
                        aspectRatio: "4/5", // Standardized portrait look for art
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "20px",
                        border: "1px solid #f0f0f0"
                      }}>
                        <img
                          src={item.cover || NoImage}
                          alt={item.d_desc}
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            objectFit: "contain",
                            transition: "transform 0.6s cubic-bezier(0.25, 1, 0.5, 1)"
                          }}
                          onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                          onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                        />
                      </div>

                      
                      <div style={{ textAlign: "left" }}>
                        <p style={{ 
                          textTransform: "uppercase", 
                          fontSize: "11px", 
                          letterSpacing: "1px", 
                          color: "#888",
                          marginBottom: "8px" 
                        }}>
                          {item.auction_status}
                        </p>
                        <h2 style={{ 
                          fontFamily: "serif", 
                          fontSize: "20px", 
                          lineHeight: "1.4",
                          marginBottom: "10px",
                          color: "#1a1a1a"
                        }}>
                          {item.d_desc}
                        </h2>
                        <p style={{ fontSize: "14px", color: "#555" }}>
                          {dateStart} — {dateEnd}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : !loading && (
              <div style={{ width: "100%", textAlign: "center", padding: "100px 0", color: "#999", fontStyle: "italic" }}>
                No exhibitions currently found.
              </div>
            )}
          </div>
        </div>
      </section>

      
      <Backdrop sx={{ color: "#fff", zIndex: 9999 }} open={loading}>
        <CircularProgress color="inherit" thickness={2} />
      </Backdrop>
    </div>
  );
}